import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import './NoiseEventList.css';
import NoiseEvent from './NoiseEvent.js'
import { faSmileBeam, faFrown, faHourglass, faQuestion } from '@fortawesome/free-solid-svg-icons'
import { useListVals } from 'react-firebase-hooks/database';
import moBounce from './moBounce2.gif'
import {formatTime} from './date-utils'

function NoiseEventList(props) {
  let content;
  if (props.error) {
    content = 
      <div className="message-container">
        <FontAwesomeIcon icon={faFrown} className="big-icon"/>
        <h1>Something went wrong</h1>
      </div>
  } else if (props.loading) {
    content = 
      <div className="message-container">
        <img src={moBounce} style={{height: '70px', width: '70px'}}></img>
        <h2 style={{marginTop: '0'}}>Loading...</h2>
      </div>
  } else if (props.values && props.values.length > 0) {
    content = 
      props.values?.map((noiseEvent, index) => { 
        const volume = noiseEvent.LoudNoiseHappened == 1 
                        ? 'loud' 
                        : (
                            noiseEvent.MediumNoiseHappened == 1
                            ? 'medium' 
                            : (
                              noiseEvent.QuietNoiseHappened == 1 ? 'quiet' : ''
                              )
                          );
        return (
          <NoiseEvent 
            key = {index}
            volume={volume}
            timestampMinutes={formatTime(noiseEvent.NoiseTimestampMinute)}
            timestampSeconds={formatTime(noiseEvent.NoiseTimestampSecond)}
            startTime={props.startTime}
          />
        )
      });
  } else if (props.values.length == 0) {
    content = 
      <div className="message-container">
        <FontAwesomeIcon icon={faSmileBeam} className="big-icon"/>
        <h1>Hooray!!</h1>
        <span>No barks have happened yet</span>
      </div>
  } else {
    content = 
      <div className="message-container">
        <FontAwesomeIcon icon={faQuestion} className="big-icon"/>
        <h1>Not Sure</h1>
        <span>This is embarassing... I don't know what to display</span>
      </div>
  }

  return (
    <div>
      { content }
    </div>
  );
}

export {NoiseEventList}
